import React, { useCallback, useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import Logo from 'components/shared/Logo';

import { ItemsContext } from './context/ItemsContextProvider';
import { ToastContext } from 'components/shared/context/ToastContextProvider';
import { UserContext } from 'components/shared/context/UserContextProvider';

import SecondaryButton from 'components/shared/buttons/SecondaryButton';

const NavbarContainer = styled.div`
  width: 100vw;
  height: 60px;
  background-color: #ffffff;

  z-index: 1;
  position: fixed;
  top: 0;
  left: 0;

  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 0px 20px;

  box-shadow: rgb(204, 219, 232) 3px 3px 6px 0px,
    rgba(255, 255, 255, 0.5) -3px -3px 6px 1px;
`;

const Filler = styled.div`
  /* pushes down page content by height of navbar */

  width: 100vw;
  height: 60px;
`;

const Navbar: React.FC = () => {
  const { userDispatch } = useContext(UserContext);
  const { toastDispatch } = useContext(ToastContext);
  const { setItems } = useContext(ItemsContext);

  const [isButtonLoading, setIsButtonLoading] = useState(false);

  const onClick = useCallback(() => {
    if (userDispatch) {
      setIsButtonLoading(true);
      setTimeout(() => {
        userDispatch({ type: 'SIGNOUT' });
        setItems?.([]);
        toastDispatch?.({ type: 'SUCCESS', message: 'Signed out' });
      }, 500);
    }
  }, [userDispatch, toastDispatch, setItems]);

  return (
    <div>
      <NavbarContainer>
        <Link to="/">
          <Logo scale={40} showText={false} />
        </Link>
        <SecondaryButton
          buttonText="Sign out"
          disabled={false}
          loading={isButtonLoading}
          buttonWidth="105px"
          onClick={onClick}
        />
      </NavbarContainer>
      <Filler />
    </div>
  );
};

export default Navbar;
